var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-back",on:{"click":_vm.backClick}},[_c('i',{staticClass:"el-icon-arrow-left back-icon"}),_c('el-link',{staticClass:"back-txt"},[_vm._v("Back")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }